import http from '@/http-common'

class SegnalazioniDataService {
  getSegnalazioneById (id) {
    return http.get(`segnalazione/${id}`)
  }

  getSegnalazioniByServizioId (id) {
    return http.get(`servizio/${id}/segnalazionifiltered`)
  }

  getSegnalazioniByCommuneId (id) {
    return http.get(`comune/${id}/segnalazioni`)
  }

  cerca (id, cerca) {
    return http.get(`comune/${id}/segnalazioni/${cerca}`)
  }

  postSegnalazione (id, data) {
    return http.post(`servizio/${id}/segnalazione`, data)
  }

  update (id, data) {
    return http.put(`segnalazione/${id}/stato`, data)
  }

  delete (id) {
    return http.delete(`segnalazione/${id}`)
  }
}

export default new SegnalazioniDataService()
